import { createContext } from "react";

export const LayoutContext = createContext();

export const layoutState = {
  leathers: [],
  totalArea: 0,
  activeTab: "overview", // Mặc định vào Dashboard (Thống kê)
};

export const layoutReducer = (state, action) => {
  switch (action.type) {
    case "ADD_LEATHER":
      return {
        ...state,
        leathers: [...state.leathers, action.payload],
        totalArea: state.totalArea + parseFloat(action.payload.area),
      };
    // THÊM CASE NÀY ĐỂ CHUYỂN TRANG
    case "CHANGE_TAB":
      return {
        ...state,
        activeTab: action.payload,
      };
    default:
      return state;
  }
};